import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  updateUserSettings,
  UserSettingsUpdateRequest,
} from '../../../../apis/userSettings'
import { queryKeys } from '../../../../shared'

/**
 * ユーザー設定を更新する Mutation hook
 *
 * 更新成功時は invalidateQueries により設定キャッシュが自動更新される。
 */
export const useUpdateUserSettingsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (updates: UserSettingsUpdateRequest) =>
      updateUserSettings(updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.userSettings.all })
    },
  })
}
